<div class="poi-container mb-2" matRipple (click)="click()">
    <div class="poi-icon">
        <!-- <button mat-icon-button>
            <mat-icon>keyboard_arrow_right</mat-icon>
        </button> -->
        <div [hidden]="!data.iconName">
            <img [src]="'assets/icons/'+data.iconName+'.svg'" alt="" width="40">
        </div>

        <div *ngIf="data.data.contentType?.toLowerCase() == 'line'">
            <mat-icon style="font-size: 40px;height: 40px;width: 40px;">linear_scale</mat-icon>
        </div>

        <div *ngIf="data.data.contentType?.toLowerCase() == 'polygon'">
            <mat-icon style="font-size: 40px;height: 40px;width: 40px;">polyline</mat-icon>
        </div>
    </div>
    <table class="poi-info">
        <tr>
            <td>{{data.data.shortName}}</td>
        </tr>
        <tr>
            <td>{{data.data.getTypeTitle()}} &#183; {{data.data.huntingDistrictName}}</td>
        </tr>
        @if (data.data.planningStatus){
            <tr>
                <td>{{'FORM.poiForm.planningStatusOptions.'+ data.data.planningStatus | translate}} </td>
            </tr>          
        }
    </table>
    <!-- icon am Ende -->
    <div class="poi-icon">
        <button mat-icon-button (click)="click()">
            <mat-icon>keyboard_arrow_right</mat-icon>
        </button>
    </div>
</div>
